import { render, staticRenderFns } from "./PanelDetails.vue?vue&type=template&id=13e5ad6e&"
import script from "./PanelDetails.vue?vue&type=script&lang=js&"
export * from "./PanelDetails.vue?vue&type=script&lang=js&"
import style0 from "./PanelDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports